import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { computed } from 'vue'

import { TripFull } from '@/models/trip'
import { DamageReportStatus } from '@/models/damageReport'

import { RbacAction, RbacEntity } from '@/helpers/rbac'

import { useTripsStore } from '@/store/trips'

import DamageReportItem from '@/components/DamageReportItem.vue'
import useScopeCheck from '@/composables/useScopeCheck'


export default /*@__PURE__*/_defineComponent({
  __name: 'DamageReportsSection',
  props: {
    trip: {}
  },
  setup(__props: any) {

const props = __props

const tripsStore = useTripsStore()

const allowedEditing = useScopeCheck(RbacAction.UPDATE, RbacEntity.TRIPS)

const reportsModule =
  tripsStore.tripsDetails[props.trip.id]?.damageReportsModule

const loadingList = computed(() => reportsModule?.updating.loadingList || [])

const handleResolveClick = (tripId: string, reportId: string) => {
  tripsStore.updateDamageReportStatus(
    tripId,
    reportId,
    DamageReportStatus.RESOLVED
  )
}

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createBlock(_component_el_row, { class: "table-container" }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trip.damage_reports, (report) => {
        return (_openBlock(), _createBlock(_component_el_col, {
          span: 24,
          key: report.id
        }, {
          default: _withCtx(() => [
            _createVNode(DamageReportItem, {
              editable: _unref(allowedEditing),
              trip: _ctx.trip,
              report: report,
              isResolving: loadingList.value.includes(report.id),
              onResolve: handleResolveClick
            }, null, 8, ["editable", "trip", "report", "isResolving"])
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }))
}
}

})